// Public editorial metadata only. Also supplies the analytics route allowlist.
export const LANDLORD_GUIDES = [
  {
    slug: "renew-or-relet-dubai-tenant",
    title:
      "Renew or re-let? What replacing a good tenant really costs in Dubai",
    seoTitle: "Renew or Find a New Tenant in Dubai? 2026 Data",
    category: "Renewals & market data",
    description:
      "New Dubai tenants paid just 4.2% more in 2026, and almost half of units sat empty over three weeks. When renewing beats re-letting, area by area.",
    modifiedOn: "2026-10-27",
  },
  {
    slug: "how-much-rent-dubai-property",
    title:
      "How much rent can I charge in Dubai? What 73,000 new tenants paid in 2026",
    seoTitle: "How Much Rent Can I Charge in Dubai? 2026 Data",
    category: "Rental pricing",
    description:
      "New Dubai tenants paid a median AED 65,000 in 2026, 2.2% less than a year earlier for the same flats. What to ask, by area, and what asking high costs.",
    modifiedOn: "2026-10-28",
  },
  {
    slug: "dubai-renewal-rent-increase",
    title:
      "How much can a Dubai landlord raise the rent? What 360,000 renewals show",
    seoTitle: "Dubai Rent Increase: How Much Can a Landlord Add?",
    category: "Renewals & market data",
    description:
      "The RERA index caps a Dubai rent increase at 0–20%. In 360,000 renewals in 2025–26, 45% kept the rent the same. What's allowed, and what works.",
    modifiedOn: "2026-10-28",
  },
  {
    slug: "dubai-security-deposit-refund",
    title:
      "What a Dubai landlord can keep from the security deposit, and what holds up at the RDC",
    seoTitle: "Dubai Security Deposit: What a Landlord Can Keep",
    category: "Deposits & move-out",
    description:
      "What a Dubai landlord can keep from a security deposit. Tenants won 72% of deposit claims; landlords with a pre-case inspection won 79% of damage cases.",
    modifiedOn: "2026-10-28",
  },
  {
    slug: "dubai-tenancy-early-termination",
    title:
      "When a Dubai tenant wants to leave early: what the law allows and what landlords recover",
    seoTitle: "Early Termination in Dubai: Penalty and Rights",
    category: "Ending a tenancy",
    description:
      "No Dubai law sets a penalty for leaving a lease early. At the RDC, landlords won a third of early-exit claims; most awards were two months' rent.",
    modifiedOn: "2026-10-28",
  },
  {
    slug: "dubai-landlord-notice-deadlines",
    title:
      "Every Dubai landlord deadline on one page, and the notices that go with them",
    seoTitle: "Dubai Landlord Notice Periods & Eviction Notices",
    category: "Notices & disputes",
    description:
      "Dubai's 90-day renewal notice, 30-day rent notice and 12-month eviction notice: how to serve each, and where landlords lose at the RDC.",
    modifiedOn: "2026-10-27",
  },
  {
    slug: "dubai-unpaid-rent-rdc-process",
    title:
      "From missed rent to a Rental Disputes Centre verdict: how long it takes and what it costs",
    seoTitle: "Tenant Not Paying Rent in Dubai: RDC Steps & Fees",
    category: "Notices & disputes",
    description:
      "Tenant not paying rent? The RDC now decides most cases in about two weeks, and landlords win 99% of them. The steps, the fees and the costly mistake.",
    modifiedOn: "2026-10-28",
  },
  {
    slug: "dubai-vacant-property-cost",
    title: "What an empty month really costs a Dubai landlord",
    seoTitle: "Dubai Service Charges and Empty-Month Costs",
    category: "Costs & yields",
    description:
      "Service charges take 12–19% of rent and don't stop when the tenant leaves. What an empty month costs a Dubai landlord, community by community.",
    modifiedOn: "2026-10-27",
  },
  {
    slug: "dubai-property-management-what-you-pay-for",
    title:
      "What your 5–8% should buy: a Dubai rental you don't have to think about",
    seoTitle: "Property Management Fees in Dubai: What 5–8% Buys",
    category: "Costs & yields",
    description:
      "Dubai property management costs 5–8% of rent, up to about a tenth of what a rental really earns. What good management should give you back.",
    modifiedOn: "2026-10-27",
  },
  {
    slug: "dubai-landlord-maintenance-cost",
    title: "The repair you put off is the one that costs you most",
    seoTitle: "Landlord Maintenance in Dubai: Who Pays What",
    category: "Maintenance",
    description:
      "In Dubai the landlord is responsible for repairs unless the contract says otherwise. RDC verdicts show what slow repairs end up costing.",
    modifiedOn: "2026-10-27",
  },
  {
    slug: "dubai-rental-yields-by-area",
    title: "Dubai rental yields by area: what landlords actually keep",
    seoTitle: "Dubai Rental Yields by Area (2026): What You Keep",
    category: "Costs & yields",
    description:
      "Apartment yields across 21 Dubai communities from DLD data: the headline gross yield, then after service charges, empty weeks and maintenance.",
    modifiedOn: "2026-10-27",
  },
] as const;

export type LandlordGuide = (typeof LANDLORD_GUIDES)[number];

export function guidePath(slug: string): string {
  return `/insights/landlord-guides/${slug}/`;
}
